import type { EntryPatch, TodayResponse, RangeResponse, DailyEntry } from '@tally/lib/types';

const API_BASE = import.meta.env.DEV ? '' : 'https://tally.talamiram.workers.dev';

async function j<T>(r: Response): Promise<T> {
  if (!r.ok) throw new ApiError(r.status, await r.text());
  return (await r.json()) as T;
}

export class ApiError extends Error {
  constructor(public status: number, public body: string) {
    super(`API ${status}: ${body}`);
  }
}

export async function getToday(date?: string): Promise<TodayResponse> {
  const u = new URL(`${API_BASE}/api/today`, location.origin);
  if (date) u.searchParams.set('date', date);
  return j(await fetch(u.toString()));
}
export async function getRange(start: string, end: string): Promise<RangeResponse> {
  const u = new URL(`${API_BASE}/api/range`, location.origin);
  u.searchParams.set('start', start);
  u.searchParams.set('end', end);
  return j(await fetch(u.toString()));
}
export async function saveEntry(patch: EntryPatch): Promise<DailyEntry> {
  return j(await fetch(`${API_BASE}/api/entry`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch),
  }));
}
export async function uploadCronometerCsv(csv: string): Promise<{ written: number }> {
  return j(await fetch(`${API_BASE}/api/entry/csv/cronometer`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ csv }),
  }));
}
export interface SyncSummary {
  whoop: 'ok' | 'error' | 'skipped';
  withings: 'ok' | 'error' | 'skipped';
  cronometer: 'ok' | 'error' | 'stale' | 'skipped';
  errors: Record<string, string>;
}

export async function triggerSync(opts: { fresh?: boolean } = {}): Promise<SyncSummary> {
  const url = `${API_BASE}/oauth/sync/run${opts.fresh ? '?fresh=1' : ''}`;
  return j<SyncSummary>(await fetch(url, { method: 'POST' }));
}
